import { useEffect } from "react"
import { Navigate, useParams } from "react-router-dom"

import { SCM_SIGN_IN_PURPOSES } from "@/const/scm-sign-in.constants"
import { saveScmLinkSlug } from "@/helpers/scm-session.helpers"
import {
  getPolicyExceptionPath,
  getScmSignInPath
} from "@/helpers/signin.helpers"

import type { PolicyExceptionLinkRedirectProps } from "."

// The slug only picks the tenant; without a Kodem session, sign in with the scan's SCM.
export const PolicyExceptionLinkRedirect = ({
  authorizedUser
}: PolicyExceptionLinkRedirectProps) => {
  const { slug = "", scanId = "" } = useParams()
  const to = authorizedUser
    ? getPolicyExceptionPath(scanId)
    : getScmSignInPath(SCM_SIGN_IN_PURPOSES.POLICY_EXCEPTION, slug, scanId)

  // The Kodem page has no slug in its URL; keep it in case the session turns out expired.
  useEffect(() => {
    if (authorizedUser) saveScmLinkSlug(scanId, slug)
  }, [authorizedUser, scanId, slug])

  return <Navigate to={to} replace />
}
